import { render, staticRenderFns } from "./Antiseptics.vue?vue&type=template&id=2c0764c3&scoped=true&"
import script from "./Antiseptics.vue?vue&type=script&lang=js&"
export * from "./Antiseptics.vue?vue&type=script&lang=js&"
import style0 from "./Antiseptics.vue?vue&type=style&index=0&id=2c0764c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0764c3",
  null
  
)

export default component.exports